import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const EngagementLetterActions = {
  createEngagementLetter: async ({ commit }, payload) => {
    return axiosRequest.
      post('/legal_cases/engagement_letters', { engagement_letter: payload }).
      then(({ data }) => data).
      catch(handleError)
  },
}
